import React, { FC } from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";
import mergeClasses from "classnames";
import useStyles from "./styles";

export interface DPButtonProps extends ButtonProps {
  align?: "left" | "right" | "center";
  component?: string;
}

const DPButton: FC<DPButtonProps> = props => {
  const classes = useStyles();
  const {
    className,
    align = "center",
    color = "primary",
    variant = "contained",
    component = "button",
  } = props;

  const mergedClasses = mergeClasses(className, classes[align]);
  const mergedProps = {
    ...props,
    color,
    variant,
    component,
    className: mergedClasses,
  };
  delete mergedProps.align;

  return <Button {...mergedProps} />;
};

export default DPButton;
